import { NgModule } from '@angular/core';
import { SelectAllDirective } from './select-all/select-all';
@NgModule({
	declarations: [SelectAllDirective],
	imports: [],
	exports: [SelectAllDirective]
})
export class DirectivesModule {}



// WEBPACK FOOTER //
// ./src/directives/directives.module.ts